import React, { useMemo, useState, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import "./A3PackDetails.css";
import RadioButtunTable from "../../CommonUtils/RadioButtunTable/RadioButtunTable";
import { FaPlus, FaMinus } from "react-icons/fa"; 



const normalizeLangGenreRow = (row) => {
  if (row && typeof row === "object" && !Array.isArray(row)) {
    return {
      name: row.languageName || row.genre || row.Genre || "-",
      count: row.channelcount?.noOfChannels || "-"
    };
  }
  if (Array.isArray(row)) {
    return {
      name: row[0],
      count: row[1]?.noOfChannels || "-"
    };
  }
  return { name: "-", count: "-" };
};

const renderChannelCountInline = (countObj) => {
  if (!countObj) return "";
  return `${countObj.noOfChannels} (SD: ${countObj.noOfSDChannels}, HD: ${countObj.noOfHDChannels})`;
};

const getCellForHeader = (svc, headerText) => {
  
  switch (headerText) {
    case "Services":
    case "Product":
    case "Pack Name":
      return svc?.service 
      ? svc.service 
      : svc?.product 
        ? svc.product 
        : "";
    case "Pack Friendly Name":
      return svc?.packFriendlyName ?? "";
    case "Service Type":
    case "Product Type":
    case "Pack Type":
      return svc?.serviceType ? svc?.serviceType : svc?.productType ?  svc?.productType : "";
    case "Product ID": 
      return svc?.productId ?? "";
    case "Start Date":
      return svc?.startDate ?? "";
    case "End Date":
    case "End date":
      return svc.endDate ?? "";
    case "Source":
      return svc.source ?? "";
    case "Rental Counter":
      return svc.rentalConter ?? "";
    case "Channel Count":
      return renderChannelCountInline(svc.channelCount);
    case "Channel list":
    case "App list":
      return "Click Here";
    case "App Count": 
    return svc.appList?.channelData?.[0]?.data?.length 
    ?? svc.appCount 
    ?? "";

    case "MBR":
      return svc.mbr ? `Rs. ${svc.mbr}/- per month` : "";
    case "Status":
      return svc.status ?? "";
    default:
      return svc[headerText] ?? "";
  }
};




// export const useOutsideClick = (ref, onClose) => {
//   useEffect(() => {
//     const handler = (e) => {
//       // check if click is outside
//       if (ref.current && !ref.current.contains(e.target)) {
//         onClose();
//       }
//     };

//     document.addEventListener("mousedown", handler);
//     return () => document.removeEventListener("mousedown", handler);
//   }, [ref, onClose]);
// };



// -------------------- FilterDropdown --------------------
const FilterDropdown = ({ values, selected, onChange, onSortChange, placeholder = "Filter" }) => {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const boxRef = useRef(null);
  const [sortOrder, setSortOrder] = useState("asc"); // ✅ existing state kept

  const visibleValues = useMemo(() => {
    const q = query.trim().toLowerCase();
    return q ? values.filter((v) => String(v).toLowerCase().includes(q)) : values;
  }, [values, query]);

  const toggleValue = (v) => {
    const next = new Set(selected);
    if (next.has(v)) next.delete(v);
    else next.add(v);
    onChange(next);
  };

  const allSelected = selected.size > 0 && selected.size === values.length;

  return (
    <div className="filter-wrap">
      <button
        type="button"
        className={`filter-btn ${selected.size ? "active" : ""}`}
        onClick={() => setOpen((o) => !o)}
        title="Filter"
      >
        {selected.size > 0 ? "✅" : "▾"}
      </button>

      {open &&
        createPortal(
          <div className="filter-overlay">
            <div className="filter-dropdown" ref={boxRef}>
              <div className="filter-actions">
                <button
                  type="button"
                  onClick={() => onChange(new Set(values))}
                  className="mini-btn"
                >
                  Select all
                </button>

                {/* ✅ Sort button updated to also notify parent */}
                <button
                  type="button"
                  onClick={() => {
                    const nextOrder = sortOrder === "asc" ? "desc" : "asc";
                    setSortOrder(nextOrder);
                    onSortChange?.(nextOrder); // ✅ new line — triggers parent sort
                  }}
                  className="mini-btn"
                >
                  Sort {sortOrder === "asc" ? "↓" : "↑"}
                </button>

                <button
                  type="button"
                  onClick={() => {
                    setQuery("");
                    onChange(new Set());
                  }}
                  className="mini-btn"
                >
                  Clear
                </button>
              </div>

              <input
                className="filter-search"
                value={query}
                placeholder={placeholder}
                onChange={(e) => setQuery(e?.target?.value)}
              />

              <div className="filter-list">
                {values.length === 0 ? (
                  <div className="filter-empty">No values</div>
                ) : (
                  [...visibleValues]
                    .sort((a, b) => {
                      const isNumeric = !isNaN(a) && !isNaN(b);
                      if (isNumeric) {
                        return sortOrder === "asc" ? a - b : b - a;
                      }
                      return sortOrder === "asc"
                        ? String(a).localeCompare(String(b))
                        : String(b).localeCompare(String(a));
                    })
                    .map((v, i) => (
                      <label
                        key={i}
                        className="packs-filter-item A3f"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <input
                          type="checkbox"
                          checked={selected.has(v)}
                          onChange={(e) => {
                            e.stopPropagation();
                            toggleValue(v);
                          }}
                        />
                        <span>{v || "(blank)"}</span>
                      </label>
                    ))
                )}
              </div>

              <div className="filter-footer">
                <span className="filter-status">
                  {selected.size
                    ? `${selected.size} of ${values.length} selected`
                    : allSelected
                    ? `All (${values.length})`
                    : "No filter"}
                </span>
                <div className="filter-buttons">
                  <button
                    type="button"
                    className="close-btn"
                    onClick={() => {
                      setOpen(false);
                      onChange(new Set());
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="proceed-btn"
                    onClick={() => {
                      onChange(new Set(selected));
                      setOpen(false);
                    }}
                  >
                    Proceed
                  </button>
                </div>
              </div>
            </div>
          </div>,
          document.body
        )}
    </div>
  );
};


/* ---------- Modal Component ---------- */

// const Modal = ({ children, onClose }) => {
//   const ref = useRef();
//   useOutsideClick(ref, onClose);

//   return createPortal(
//     <div className="filter-overlay">
//       <div className="filter-dropdown" ref={ref}>
//         {children}
//       </div>
//     </div>,
//     document.body
//   );
// };
// const Modal = ({ children, onClose }) => {
//   const ref = useRef();

//   useOutsideClick(ref, (e) => {
//     // Only close if clicking the overlay itself, not interactive elements inside
//     if (e.target === e?.currentTarget || !ref.current.contains(e?.target)) {
//       onClose();
//     }
//   });

//   return createPortal(
//     <div className="filter-overlay">
//       <div className="filter-dropdown" ref={ref}>
//         {children}
//       </div>
//     </div>,
//     document.body
//   );
// };
const Modal = ({ children, onClose }) => {
  const ref = useRef();

  // useOutsideClick(ref, onClose);

  // Prevent clicks inside modal from bubbling to document
  const handleClickInside = (e) => {
    e.stopPropagation();
  };

  return createPortal(
    <div className="filter-overlay">
      
      <div className="filter-dropdown-modal" ref={ref} onClick={handleClickInside}>
        {children}
      </div>
    </div>,
    document.body
  );
};

const OTTModal = ({ children, onClose }) => {
  const ref = useRef();

  const handleClickInside = (e) => e.stopPropagation();

  return createPortal(
    <div className="filter-overlay" onClick={onClose}>
      <div
        className="filter-dropdown-modal"
        ref={ref}
        onClick={handleClickInside}
      >
        {children}
      </div>
    </div>,
    document.body
  );
};




/* ---------- AutoSelectCheckbox Component ---------- */
const AutoSelectCheckbox = React.memo(({ svc, selectedServices, toggleSelect, setErrors, propsIndex, setSelectedServices }) => {
  const initializedRef = useRef(false);

  useEffect(() => {
    if (svc?.isAutoSelected && !selectedServices.has(svc.service) && !initializedRef.current) {
      initializedRef.current = true;
      
      const newService = svc.service;
      setSelectedServices(prev => new Set(prev).add(newService));
      
      queueMicrotask(() => {
        setErrors(prevErrors => {
          // const updatedServices = new Set(selectedServices);
          // updatedServices.add(newService);
          const existing = prevErrors[propsIndex];
          const existingServices = existing?.key1 ? existing.key1.split(',') : [];
          const existingDisplay = existing?.displayName || [];
          
          const newServices = [...new Set([...existingServices, svc.service])];
          const newDisplay = [...new Set([...existingDisplay, svc.service])];
          
          return {
            ...prevErrors,
            [propsIndex]: {
              // key1: Array.from(updatedServices).join(","),
              // displayName: Array.from(updatedServices),
              key1: newServices.join(','),
              displayName: newServices.join(',')

            }
          };
        });
      });
    }
  }, [svc?.isAutoSelected, svc?.service]);

  return (
    <input
      type="checkbox"
      className={svc.isAutoSelected ? "auto-green" : ""}
      checked={selectedServices.has(svc.service) || svc.isAutoSelected}
      onClick={(e) => e.stopPropagation()}
      onChange={() => toggleSelect(svc)}
    />
  );
});

/* ---------- Main Component ---------- */

const A3PackDetails = (props) => {
  const {item, errors, setErrors, index, addMessages, showMaximumChat, setIsShowMaximumChat ,showMaxScreen } = props
  
  let data;
  try {
    data = JSON.parse(item?.text); // try to parse as JSON
  } catch (e) {
    data = item || "";       // fallback to normal text
  }
  const [expanded, setExpanded] = useState({});
  const [subFilters, setSubFilters] = useState({});
  const [selectedServices, setSelectedServices] = useState(new Set());
  const [modalData, setModalData] = useState(null);
  const [ottModalData, setOttModalData] = useState(null);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [tableSort, setTableSort] = useState({}); 


    // helper: extract the first numeric value from a string (returns number or 0)
    const parseLeadingNumber= (val) => {
      if (val == null) return 0;
      // if already a number
      if (typeof val === "number" && !isNaN(val)) return val;

      const s = String(val);
      // find first occurrence of a number (allow commas and decimals)
      const m = s.match(/-?[\d,]+(?:\.\d+)?/);
      if (!m) return 0;
      // remove commas then parse
      const num = parseFloat(m[0].replace(/,/g, ""));
      return isNaN(num) ? 0 : num;
    }

  //Collapse
  const [collapsed, setCollapsed] = useState(true);

  const toggleCollapse = () => setCollapsed(!collapsed);

  const toggleSelect = (pack) => {
    setSelectedServices((prev) => {
      const next = new Set(prev);
      if (next.has(pack.service)) next.delete(pack.service);
      else next.add(pack.service);

      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        const selectedArray = Array.from(next);
        if (selectedArray.length === 0) {
          delete updatedErrors[index];
        } else {
          updatedErrors[index] = {
            key1: selectedArray.join(","),
            displayName: selectedArray,
          };
        }
        return updatedErrors;
      });
      return next;
    });
  };

  //  clear filters
  const clearAllFilters = () => {
    if (!modalData) return;
  
    // --- Languages ---
    const langTable = modalData.svc.channelList?.languageTable;
    if (langTable) {
      langTable.headings.forEach((h) => {
        setSubFilter(`${modalData.sIdx}-${modalData.rowIdx}-lang`, h, new Set());
      });
    }
  
    // --- Genres ---
    const genreTable = modalData.svc.channelList?.genreTable;
    if (genreTable) {
      genreTable.headings.forEach((h) => {
        setSubFilter(`${modalData.sIdx}-${modalData.rowIdx}-genre`, h, new Set());
      });
    }
  
    // --- Channels ---
    const channelTable = modalData.svc.channelList;
    if (channelTable?.listOfHeadings) {
      channelTable.listOfHeadings.forEach((h) => {
        setSubFilter(`${modalData.sIdx}-${modalData.rowIdx}-channels`, h, new Set());
      });
    }
  
    // --- Apps ---
    // const appTable = modalData.svc.appList;
    // if (appTable?.listOfHeadings) {
    //   appTable.listOfHeadings.forEach((h) => {
    //     setSubFilter(`${modalData.sIdx}-${modalData.rowIdx}-apps`, h, new Set());
    //   });
    // }
  };
  
  
  
  

  const toggleExpand = (serviceIdx, rowIdx) => {
    const key = `${serviceIdx}-${rowIdx}`;
    setExpanded((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const setSubFilter = (tableKey, header, setVal) => {
    const key = `${tableKey}::${header}`;
    setSubFilters((prev) => {
      const next = { ...prev, [key]: setVal };
      if (header === "Language") next[`${tableKey.replace(/-lang$/, "-channels")}::Language`] = setVal;
      if (header === "Genre") next[`${tableKey.replace(/-genre$/, "-channels")}::Genre`] = setVal;
      return next;
    });
  };

  const getSubFilter = (tableKey, header) => {
    const key = `${tableKey}::${header}`;
    return subFilters[key] ?? new Set();
  };

  const renderSubTable = (table, title, tableKey) => {
    if (!table) return null;
  
    // --- collect unique values for each header ---
    const headerUniqueValues = {};
    table.headings.forEach((h, idx) => {
      const vals =
        idx === 0
          ? table.data.map((row) => row.optionName)
          : table.data.map((row) => row.channelCount?.noOfChannels);
      headerUniqueValues[h] = Array.from(new Set(vals));
    });
  
    return (
      <div style={{ height: !collapsed && "250px"}} className="sub-table table-scroll">
        <h4
          onClick={toggleCollapse}
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: !collapsed && "20px"
          }}
        >
          <span>{title}</span>
          <span className="toggle">{collapsed ? <FaPlus /> : <FaMinus />}</span>
        </h4>
  
        {!collapsed && (
          <table>
            <thead>
              <tr>
                {table.headings.map((h, idx) => (
                  <th key={idx}>
                    <div className="th-inner A3f">
                      <span>{h}</span>
                      <FilterDropdown
                        values={headerUniqueValues[h]}
                        selected={getSubFilter(tableKey, h)}
                        onChange={(setVal) => setSubFilter(tableKey, h, setVal)}
                        placeholder={`Search ${h}`}
                      />
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
  
            <tbody>
              {table.data.map((row, idx) => {
                const nameSet  = getSubFilter(tableKey, table?.headings[0]);
                const countSet = getSubFilter(tableKey, table?.headings[1]);

              
                const nameHighlighted =
                  nameSet?.size > 0 && nameSet.has(row?.optionName);

                const countHighlighted =
                  countSet?.size > 0 &&
                  countSet.has(row.channelCount?.noOfChannels);

                return (
                  <tr key={idx}>
                    <td className={nameHighlighted ? "filtered-selected" : ""}>
                      {row.optionName}
                    </td>

                    <td
                      className={`channel-count ${
                        countHighlighted ? "filtered-selected" : ""
                      }`}
                    >
                      {row?.channelCount && (
                        <div className="channel-count-wrapper-popup">
                          <span className="hannel-count-total">
                            {row?.channelCount?.noOfChannels}
                          </span>

                          <div className="hannel-count-group">
                            <span className="hannel-count-box">
                              {row?.channelCount?.noOfHDChannels}
                            </span>
                            <span className="hannel-count-pill">HD</span>
                          </div>

                          <div className="hannel-count-group">
                            <span className="hannel-count-box">
                              {row?.channelCount?.noOfSDChannels}
                            </span>
                            <span className="hannel-count-pill">SD</span>
                          </div>
                        </div>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>

          </table>
        )}
      </div>
    );
  };
  

  const renderOTTCombos = (channelList, tableKey)=>{
    if (!channelList) return null;
    if(!channelList?.channelData?.isOTT)  return null;
    return (
      <div style={{marginTop : '16px'}} className="sub-table table-scroll">
        <h4>OTT Apps</h4>
        <div style={{display:'flex' , justifyContent : 'center' ,height :'90px' , bottom :'10px' ,position:'relative'}}><img  src={channelList?.channelData?.imageLink}></img></div>
      </div>
    );
  }   
  // -------------------- renderChannelTable --------------------
const renderChannelTable = (channelList, tableKey) => {
  

  if (!channelList) return null;
  const headers = channelList.listOfHeadings || [];
  let allRows = [];
  if (Array.isArray(channelList?.channelData)) allRows = channelList.channelData.flatMap((block) => block.data || []);
  else if (channelList?.channelData?.data) allRows = channelList.channelData.data;

  const headerUniqueValues = {};
  headers.forEach((h, idx) => {
    headerUniqueValues[h] = Array.from(new Set(allRows.map((row) => row[idx])));
  });

  const rowsFiltered = allRows.filter((row) =>
    headers.every((h, idx) => {
      const val = row[idx];
      const set = getSubFilter(tableKey, h);
      return !set || set.size === 0 ? true : set.has(val);
    })
  );

  // ✅ Apply table-level sorting if active
  const sortConfig = tableSort[tableKey];
  if (sortConfig) {
    const colIdx = headers.indexOf(sortConfig.column);
    rowsFiltered.sort((a, b) => {
      const A = a[colIdx];
      const B = b[colIdx];
      const isNumeric = !isNaN(A) && !isNaN(B);
      if (isNumeric) return sortConfig.order === "asc" ? A - B : B - A;
      return sortConfig.order === "asc"
        ? String(A).localeCompare(String(B))
        : String(B).localeCompare(String(A));
    });
  }

  return (
    <div className="sub-table table-scroll">
      <h4>{channelList?.name}</h4>
      <table>
        <thead>
          <tr>
            {headers.map((h, idx) => (
              <th key={idx}>
                <div className="th-inner A3f">
                  <span>{h}</span>
                  <FilterDropdown
                    values={headerUniqueValues[h]}
                    selected={getSubFilter(tableKey, h)}
                    onChange={(setVal) => setSubFilter(tableKey, h, setVal)}
                    onSortChange={(order) =>
                      setTableSort((prev) => ({
                        ...prev,
                        [tableKey]: { column: h, order },
                      }))
                    } // ✅ new line only
                    placeholder={`Search ${h}`}
                  />
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rowsFiltered.map((row, rIdx) => (
            <tr key={rIdx}>
              {row.map((col, cIdx) => (
                <td key={cIdx}>{col}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

  /* --------- Small Widget Mode --------- */
  if (!showMaximumChat && !showMaxScreen) {
    return (
      <div className="a3pack-widget">
        <button
          className="fullscreen-btn"
          onClick={() => setIsShowMaximumChat(true)}
        >
          Click here to open full screen
        </button>
      </div>
    );
  }

  /* --------- Main Full View --------- */
 
  return (
    <div className="a3pack-container">
      {data?.map((section, sIdx) => {
        const hasCheckbox = section?.channelObj?.some((svc) => !!svc.isCheckBox);
  
        const uniqueKey = `${sIdx}-${section.name}`;
  
        const filteredRows = section.channelObj?.filter((svc) =>
          section.headers.every((h) => {
            const val = getCellForHeader(svc, h);
            const set = getSubFilter(`${sIdx}-main`, h);
            return !set || set.size === 0 ? true : set.has(val);
          })
        );
  
        const headerUniqueValues = {};
        section.headers.forEach((h) => {
          const vals = section.channelObj?.map((svc) => getCellForHeader(svc, h)) || [];
          headerUniqueValues[h] = Array.from(new Set(vals));
        });
  
        //  Sorting logic
        const sortableHeaders = ["Start Date", "End Date", "Channel Count", "MBR"];
  
        let sortedRows = [...(filteredRows || [])];
        const activeSort = sortConfig[uniqueKey];
        const activeKey = activeSort ? Object.keys(activeSort)[0] : null;
        const activeDirection = activeKey ? activeSort[activeKey] : null;
  
        if (activeKey && sortableHeaders.includes(activeKey)) {
          sortedRows.sort((a, b) => {
            let valA = getCellForHeader(a, activeKey);
            let valB = getCellForHeader(b, activeKey);
  
            // Handle MBR price string (extract number)
            if (activeKey === "MBR") {
              const extractNumber = (val) => {
                if (!val) return 0;
                const match = String(val).match(/(\d+(\.\d+)?)/); // captures first numeric value
                return match ? parseFloat(match[0]) : 0;
              };
            
              const numA = extractNumber(valA);
              const numB = extractNumber(valB);
            
              return activeDirection === "asc" ? numA - numB : numB - numA;
            }
            if (activeKey === "Start Date" || activeKey === "End Date") {
              const parseDate = (val) => {
                if (!val) return new Date(0); 
                const [day, month, year] = String(val).split("/").map(Number);
                return new Date(year, month - 1, day); 
              };
        
              const dateA = parseDate(valA);
              const dateB = parseDate(valB);
        
              return activeDirection === "asc"
                ? dateA - dateB
                : dateB - dateA;
            }
            
  
            // Handle Channel Count (compare total count)
            if (activeKey === "Channel Count") {
              const numA = a?.channelCount?.noOfChannels || 0;
              const numB = b?.channelCount?.noOfChannels || 0;
              return activeDirection === "asc" ? numA - numB : numB - numA;
            }
  
            // Handle numeric or string comparisons
            const isNumeric = !isNaN(valA) && !isNaN(valB);
            if (isNumeric) {
              return activeDirection === "asc" ? valA - valB : valB - valA;
            }
  
            return activeDirection === "asc"
              ? String(valA).localeCompare(String(valB))
              : String(valB).localeCompare(String(valA));
          });
        }
  
        // 🔁 Sort handler per section
        const handleSort = (uniqueKey, headerKey) => {
          setSortConfig((prev) => {
            const currentSort = prev[uniqueKey]?.[headerKey];
            const newDirection = currentSort === "asc" ? "desc" : "asc";
            return { ...prev, [uniqueKey]: { [headerKey]: newDirection } };
          });
        };
  
        return (
          <div key={sIdx} className="section table-scroll">
            <h3>{section?.name}</h3>
  
            {/* Header Table */}
            <div className="main-table-div header-table">
              <div className="table-row header-row">
                {hasCheckbox && <div className="table-cell chk-col"></div>}
                {section?.headers?.map((h, idx) => (
                  <div key={idx} className="table-cell">
                    <div className="th-inner A3f">
                      <span>{h}</span>
  
                      {/* ✅ Filter dropdown + sort button */}
                      <div className="filter-sort-wrap">
                        <FilterDropdown
                          values={headerUniqueValues[h]}
                          selected={getSubFilter(`${sIdx}-main`, h)}
                          onChange={(setVal) => setSubFilter(`${sIdx}-main`, h, setVal)}
                          placeholder={`Search ${h}`}
                        />
  
                        {sortableHeaders.includes(h) && (
                          <button
                            type="button"
                            className="sort-arrow-btn"
                            onClick={() => handleSort(uniqueKey, h)}
                            title={`Sort ${
                              activeSort?.[h] === "asc" ? "Descending" : "Ascending"
                            }`}
                          >
                            {activeKey === h
                              ? activeDirection === "asc"
                                ? "↓"
                                : "↑"
                              : "↕"}
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
  
            {/* Scrollable Body Table */}
            <div className="tbody-scroll">
              <div className="main-table-div">
                {sortedRows?.map((svc, rowIdx) => (
                  <div
                    key={rowIdx}
                    className="table-row clickable"
                    style={{
                      border: !svc?.isCheckBox && "1px solid #e5e5e5",
                      background: !svc?.isCheckBox && "#f1fff0",
                    }}
                  >
                    {hasCheckbox && (
                      <div className="table-cell chk-col A3f action-tab">
                        {svc?.isCheckBox ? (
                          // <input
                          //   type="checkbox"
                          //   checked={selectedServices.has(svc.service)}
                          //   onClick={(e) => e.stopPropagation()}
                          //   onChange={() => toggleSelect(svc)}
                          // />
                          <AutoSelectCheckbox
                          key={`${sIdx}-${rowIdx}`}
                          svc={svc}
                          selectedServices={selectedServices}
                          setSelectedServices={setSelectedServices}
                          toggleSelect={toggleSelect}
                          setErrors={setErrors}
                          propsIndex={index}
                        />
                        ) : null}
                      </div>
                    )}
  
                    {section.headers.map((h, cIdx) => {
                      if (h === "Channel Count") {
                        return (
                          <div key={cIdx} className="table-cell channel-count">
                            {svc.channelCount && (
                              <div className="channel-count-wrapper">
                                <span className="hannel-count-total">
                                  {String(svc?.channelCount?.noOfChannels ?? "").padStart(2, "0")}
                                </span>
                                <div className="hannel-count-group">
                                  <span className="hannel-count-box">
                                    {svc.channelCount.noOfHDChannels}
                                  </span>
                                  <span className="hannel-count-pill">HD</span>
                                </div>
                                <div className="hannel-count-group">
                                  <span className="hannel-count-box">
                                    {svc.channelCount.noOfSDChannels}
                                  </span>
                                  <span className="hannel-count-pill">SD</span>
                                </div>
                              </div>
                            )}
                          </div>
                        );
                      }
  
                      if ((h === "Channel list" && svc.channelList) || (h === "App list" && svc.appList)) {
                        return (
                          <div key={cIdx} className="table-cell">
                            <button
                              type="button"
                              className="link-btn"
                              onClick={(e) => {
                                e.stopPropagation();
                                setModalData({ svc, sIdx, rowIdx });
                              }}
                            >
                              Click Here
                            </button>
                          </div>
                        );
                      }
  
                      if (h === "App List" && svc?.appList) {
                        return (
                          <div key={cIdx} className="table-cell">
                            <button
                              type="button"
                              className="link-btn"
                              onClick={(e) => {
                                e.stopPropagation();
                                setOttModalData(svc?.appList);
                              }}
                            >
                              Click Here
                            </button>
                          </div>
                        );
                      }
  
                      if (h === "MBR")
                        return (
                          <div key={cIdx} className="table-cell">
                            {svc.mbr ? `${svc.mbr}` : ""}
                          </div>
                        );
  
                      if (h === "Status") {
                        return (
                          <div
                            key={cIdx}
                            className={`table-cell status ${
                              (svc.status || "").toLowerCase() === "active" ? "ok" : "bad"
                            }`}
                          >
                            {svc.status}
                          </div>
                        );
                      }
  
                      return (
                        <div key={cIdx} className="table-cell">
                          {getCellForHeader(svc, h)}
                        </div>
                      );
                    })}
                  </div>
                ))}
              </div>
            </div>
          </div>
        );
      })}
  
      {/* ---------- Modal for Click Here ---------- */}
      {modalData && (
        <Modal onClose={() => setModalData(null)}>
          <div style={{ marginBottom: "0px" }} className="modal-header">
            <button className="clear-filters" onClick={() => clearAllFilters()}>
              Clear All Filters
            </button>
            <button
              className="close-modal-btn"
              onClick={() => {
                clearAllFilters();
                setModalData(null);
              }}
            >
              ✕
            </button>
          </div>
  
          <div className="expanded-wrap">
            {modalData?.svc?.service && <h2 className="A3f">{modalData?.svc?.service}</h2>}
  
            <div className="disclaimer-container">
              <p>
                <span className="highlight-red">Selected filters</span> are marked with
                <span className="highlight-bg"> Red Font and Green Tick ( ✅ )</span>. To clear filters,
                click <span className="highlight-blue">'Clear All Filters'</span> or close the window.
              </p>
            </div>
  
            <div className="sub-tables-row">
              {renderSubTable(
                modalData.svc.channelList?.languageTable,
                "Languages",
                `${modalData.sIdx}-${modalData.rowIdx}-lang`
              )}
              {renderSubTable(
                modalData.svc.channelList?.genreTable,
                "Genres",
                `${modalData.sIdx}-${modalData.rowIdx}-genre`
              )}
            </div>
  
            {renderChannelTable(modalData.svc.channelList, `${modalData.sIdx}-${modalData.rowIdx}-channels`)}
            {renderChannelTable(modalData.svc.appList, `${modalData.sIdx}-${modalData.rowIdx}-apps`)}
            {renderOTTCombos(modalData.svc.channelList, `${modalData.sIdx}-${modalData.rowIdx}-ott`)}
          </div>
        </Modal>
      )}
  
      {ottModalData && (
        <OTTModal onClose={() => setOttModalData(null)}>
          <div className="modal-header">
            <button className="close-modal-btn" onClick={() => setOttModalData(null)}>
              ✕
            </button>
          </div>
  
          <div className="expanded-wrap">
            <RadioButtunTable item={{ text: JSON.stringify(ottModalData) }} index={0} />
          </div>
        </OTTModal>
      )}
    </div>
  );
  
  
  
};

export default A3PackDetails;
